import React, {FC} from 'react';
import {ElementWrapper} from '../element-wrapper/element-wrapper.component';
import Select from 'react-select';
import ErrorBoundary from '../error-boundary/error-boundary.component';

type Props = {
  values: SelectOption[];
  onSelect(value: any): void;
  initialValue?: any;
  label?: string;
  noPadding?: boolean;
};

export interface SelectOption {
  value: any;
  label: any;
}

export const Dropdown: FC<Props> = ({values, onSelect, initialValue, label, noPadding}) => {
  if (!values || values.length === 0) return null;

  return (
    <ElementWrapper noPadding={noPadding} title={label}>
      <div className={`${label && 'mt-2'}`}>
        <ErrorBoundary>
          <Select
            defaultValue={initialValue && values.filter(v => v.value === initialValue.id)}
            className="text-base md:text-lg"
            options={values}
            isSearchable={false}
            onChange={s => onSelect(s)}
            styles={{
              option: provided => ({
                ...provided,
                fontFamily: 'NexaBook',
              }),
              singleValue: provided => ({
                ...provided,
                fontFamily: 'NexaBook',
              }),
            }}
          />
        </ErrorBoundary>
      </div>
    </ElementWrapper>
  );
};
